import { NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { E_ShareType } from '@eureka/services/src/types/share';
import { AuthService } from '@eureka/shared/share-tools/src/domain/services/auth-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createRouter, createWebHashHistory } from 'vue-router';
import { isUserLogin } from '@eureka/utils/account';
import { isInternationalSite } from '@eureka/utils/environment';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/pages/Layout.vue'),
            redirect: '/home',
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('@/pages/home/IP.vue'),
                },
                {
                    path: '/guest',
                    name: 'guest',
                    component: () => import('@/pages/guest/guest.vue'),
                },
                // {
                //     path: '/guest/pricing',
                //     name: 'guestPricing',
                //     component: () => import('@/pages/guest/pricing.vue'),
                // },
                {
                    name: 'userSetting',
                    path: '/user-setting',
                    component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Layout.vue'),
                    beforeEnter: async(to, from, next) => {
                        if (to.name === 'userSettingPackage') {
                            return next({
                                name: 'userSettingPackageRD',
                                query: to.query,
                            })
                        }
                        next();
                    },
                    children: [
                        {
                            path: 'amount',
                            name: 'userSettingAmount',
                            component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Amount.vue'),
                        },
                        {
                            path: 'package',
                            name: 'userSettingPackage',
                            component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Package.vue'),
                        },
                        {
                            path: 'package/rd',
                            name: 'userSettingPackageRD',
                            component: () => import(/* webpackChunkName: "air-usersetting-RD" */'@/pages/user-setting/new-version/product-lines/RD.vue'),
                        }
                    ],
                },
                {
                    name: 'roadmap',
                    path: 'roadmap',
                    children: [
                        {
                            path: '',
                            name: 'roadmapHome',
                            component: () => import('@/pages/roadmap/index.vue'),
                        },
                        {
                            path: 'create',
                            name: 'roadmapCreate',
                            component: () => import('@/pages/roadmap/create.vue'),
                        }
                    ],
                },
                {
                    name: 'graph',
                    path: '/graph',
                    meta: {
                        navModuleType: NAV_MENU_TYPE.WORK_PROJECT,
                    },
                    children: [
                        {
                            path: '',
                            name: 'GraphHome',
                            component: () => import('@/pages/graph/index.vue'),
                        },
                        {
                            path: ':graph_id',
                            name: 'GraphDetail',
                            component: () => import('@/pages/graph/detail.vue'),
                            beforeEnter: async(to, from, next) => {
                                const authService = injectService<AuthService>(AuthService);
                                await authService.shareAccessCheck({
                                    data_id: to.params.graph_id as string,
                                    data_type: E_ShareType.PROJECT,
                                });
                                next();
                            },
                        },
                        {
                            path: ':graph_id/report',
                            name: 'GraphReport',
                            component: () => import('@/pages/graph/report.vue'),
                        },
                        {
                            path: ':graph_id/pdf/:item_id',
                            name: 'GraphPdf',
                            component: () => import('@/pages/graph/pdf.vue'),
                        }
                    ],
                },
                {
                    path: '/gallery',
                    name: 'gallery',
                    component: () => import('@/pages/gallery/index.vue'),
                }
            ],
        }
    ],
});

// 全局路由守卫：guest 页面访问控制
router.beforeEach(async(to, _from, next) => {
    const guestRoutes = ['/guest'];

    // 如果访问 guest 相关页面
    if (guestRoutes.includes(to.path)) {
        // 国内站点禁止访问 guest 页面，直接重定向到 home
        if (!isInternationalSite()) {
            return next('/home');
        }

        // 国际站点：已登录用户重定向到 home
        const isLogin = await isUserLogin();
        if (isLogin) {
            return next('/home');
        }
    }

    // 如果访问 home 页面
    if (to.path === '/home') {
        // 国际站点：未登录用户重定向到 guest
        if (isInternationalSite()) {
            const isLogin = await isUserLogin();
            if (!isLogin) {
                return next('/guest');
            }
        }
    }

    next();
});

export default router;
